<template>
    <div class="component-container" ref="containerDiv">
        <div class="deploy-label">Deployed Prototype</div>
        <div class="deploy-list">
                <span>
                    <div class="deploy-filename">
                        {{deployedPrototype[0].deployFile | shortName(maxChar * 1.3)}}
                    </div>
                    <div class="deploy-date">
                        {{deployedPrototype[0].uploadDate | dateFormatter}}
                    </div>
                </span>
        </div>
        <div class="deploy-label">
            <span>Archived Prototypes</span>
            <span class="button-labels">
                <span class="button-label">
                    Redeploy
                </span>
                <span class="button-label">
                    Delete
                </span>
            </span>
        </div>
        <div class="deploy-list"
             v-for="deploy in undeployedPrototypes"
             :key="deploy.deployFile"
        >
                <span>
                    <div class="deploy-filename">
                        {{deploy.deployFile | shortName(maxChar)}}
                    </div>
                    <div class="deploy-date">
                        {{deploy.uploadDate | dateFormatter}}
                    </div>
                </span>
            <span class="redeploy-buttons">
                    <button
                            type="button"
                            class="vcore_btn round-button red-button"
                            @click="removeDeploy(deploy.deployFile)"
                    >
                        <i class="vcore_icon icon-close"></i>
                    </button>
                    <button
                            type="button"
                            class="vcore_btn round-button blue-button"
                            @click="redeploy(deploy.deployFile)"
                    >
                        <i class="vcore_icon icon-move_up"></i>
                    </button>
                </span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "EditPrototype",
        props: {
          prototype: Object,
            deployed: String,
            deploys: Array,
            totalWidth: Number
        },
        methods: {
            removeDeploy(fileName){
                // eslint-disable-next-line no-console
                this.$emit('delete', fileName);
            },
            redeploy(fileName){
                this.$emit('redeploy', fileName);
            }
        },
        computed: {
            undeployedPrototypes: function () {
                if (this.deploys == []) {
                    return null;
                } else {
                    return this.deploys.filter((deploy) => {
                        return !(deploy.deployFile === this.deployed);
                    })
                }
            },
            deployedPrototype: function () {
                if (this.deploys == []) {
                    return null;
                } else {
                    return this.deploys.filter((deploy => {
                        return deploy.deployFile === this.deployed;
                    }))
                }
            },
            maxChar: function(){
                if(this.totalWidth < 440 ) { return this.totalWidth / 20; }
                if(this.totalWidth < 768 && this.totalWidth >= 440) { return this.totalWidth / 16; }
                if(this.totalWidth < 992 && this.totalWidth >= 768 ) { return this.totalWidth / 40; }
                if(this.totalWidth < 1200 && this.totalWidth >= 992) { return this.totalWidth / 33; }
                if(this.totalWidth < 1400 && this.totalWidth >= 1200) { return this.totalWidth / 28; }
                if(this.totalWidth >= 1400) { return this.totalWidth / 40;}
                /*if(this.totalWidth < 620 && this.totalWidth >= 440) { return this.totalWidth / 15; }
                if(this.totalWidth < 768 && this.totalWidth >= 620){ return this.totalWidth / 12; }
                else {
                    return 100;
                }*/
                return this.totalWidth / 15;
            }
        },
    }
</script>

<style scoped lang="scss">

    @media (min-width: 768px){
        .component-container {
            margin-left: 10px;
        }
    }

    .deploy-label{
        text-align: left;
        font-size: 24px;
        font-weight: 500;
        margin-top: 30px;
        margin-bottom: 20px;
        color: #666666;
    }

    .deploy-list {
        margin-top: 15px;
        text-align: left;
    }

    .deploy-filename {
        font-size: 18px;
        margin-bottom: 7px;
        color: #2b78e4;
    }

    .deploy-date {
        font-size: 16px;
        color: #666666;
    }

    .vcore_btn {
        float: right;
        margin-left: 5px;
    }

    .redeploy-buttons {
        position: relative;
        bottom: 38px;
        float: right;
    }

    .delete-button {
        font-size: 32px;
        color: #cc0000;
        cursor: pointer;
    }

    .small-button {
        padding: 5px 10px;
    }

    .round-button {
        width: 30px;
        height: 30px;
        border-radius: 100%;
        font-size: 18px;
        margin-left: 29px;
        margin-right: 1.5px;
        text-align: center;
    }

    .button-labels{
        float: right;
        font-size: 12px;
    }

    .button-label {
        margin-left: 15px;
        position: relative;
        top: 7px;
    }

</style>
